import { User, X } from 'lucide-react';
import type { Friend } from '@omokage/shared';
import { getUserUrl } from '@omokage/shared';

interface PlayerTagProps {
  player: Friend;
  onRemove?: (vrchatId: string) => void;
  disabled?: boolean;
}

export function PlayerTag({ player, onRemove, disabled }: PlayerTagProps) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-muted/50 rounded group transition-colors hover:bg-muted/70">
      <User className="w-4 h-4 text-muted-foreground flex-shrink-0" />
      {player.vrchatId ? (
        <a
          href={getUserUrl(player.vrchatId)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-primary hover:underline truncate flex-1"
          onClick={(e) => e.stopPropagation()}
        >
          {player.displayName}
        </a>
      ) : (
        <span className="text-sm text-card-foreground truncate flex-1">{player.displayName}</span>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={() => onRemove(player.vrchatId)}
          disabled={disabled}
          className="opacity-0 group-hover:opacity-100 p-1 hover:bg-muted rounded transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label={`Remove ${player.displayName}`}
        >
          <X className="w-3 h-3 text-muted-foreground" />
        </button>
      )}
    </div>
  );
}
